import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const EmbeddedProgrammingToolsAndOptimizationModule = () => (
  <QPhototModuleSubtopic
    title="Evolution of Embedded Programming Tools, Modelling Programs, Code Optimization, Logic Analyzers, Programming Environment"
    videos={[
      "https://www.youtube.com/embed/_vhrwPvAANw",
      "https://www.youtube.com/embed/bm0ZNnW5Fhk",
      "https://www.youtube.com/embed/Cv9ZzALVR5o",
      "https://www.youtube.com/embed/cXnWvcVQv1g",
      "https://www.youtube.com/embed/UEGhkkg-OOw"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "List any five hard real-time systems and five soft real-time systems."
      },
      {
        text:
          "Draw the Control Data Flow Graph (CDFG) for an embedded application, namely a fire alarm system."
      },
      {
        text:
          "Illustrate five code optimization techniques, providing relevant examples for each."
      },
      {
        text:
          "Propose a model to capture the behavior of a heartbeat monitoring system designed to continuously monitor a person's pulse and activate a siren alert when the heart rate exceeds a predefined threshold. The system should consist of two main tasks: pulse monitoring and siren activation."
      },
      {
        text:
          "Construct an FSM model for the scenario \"Autonomous Vehicle Component Classifier\" and also illustrate the CDFG for the system. The system operates in an automotive manufacturing plant with a mobile robot that picks, inspects, and places components. Components must be sorted by type, size, quality, and weight, and collision avoidance must be implemented. Define relevant states, events, and actions to ensure smooth and efficient operation."
      },
      {
        text:
          "Analyze the requirements and design challenges involved in code optimization for embedded system design. Based on your analysis, apply suitable optimization techniques to the provided code snippet and reorganize the code to achieve optimal performance while ensuring that relevant validations are properly incorporated."
      },
      {
        text:
          "What is a logic analyzer? Explain program analysis by drawing the DFG or CDFG for the following control structures, with one example for each: (1) if, (2) while, (3) switch, (4) for."
      },
      {
        text:
          "Identify and explain the various phases involved in translation of a program from source file to hex file for an embedded system with a neat sketch."
      },
      {
        text:
          "Propose a model to capture the behavior of a heartbeat monitoring system that continuously tracks a person's pulse and activates an alert to the doctor's interface when the heart rate exceeds a predefined threshold. The system involves two key tasks: pulse monitoring and notifying the doctor."
      },
      {
        text:
          "Find out the needs for software optimization techniques and analyze various software optimization techniques in detail with respect to embedded system software design using suitable examples."
      },
      {
        text:
          "Construct an FSM model and CDFG for the real-time embedded system \"Industrial Temperature Control System\" used in industrial environments to maintain temperature within safe operational limits. Requirements include accurate temperature measurement, real-time updates and display, and threshold alarms via audible/visual alerts. Consider relevant states, events, and actions."
      },
      {
        text:
          "Construct an FSM model for the scenario \"Pick and Place Robot\" used on a factory floor with racks of different sizes, objects supplied via conveyor belt, and a mobile robot with 360° scanning capability. Requirements include optimal rack space utilization and collision avoidance. Illustrate the CDFG for this scenario."
      },
      {
        text:
          "Investigate the challenges and issues faced by embedded system programmers. Using your findings, optimize the following code snippet and provide appropriate justifications:",
        image:"/es_1.png"
      },
      {
        text:
          "An autonomous car is programmed to move from VIT to CMC, Bagayam. The car will follow all traffic rules and is guided by inbuilt Google Maps. Construct an FSM and a CDFG for this system."
      },
      {
        text:
          "Make use of various optimization techniques in the given code and present the modified code:",
        image:"/es_2.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default EmbeddedProgrammingToolsAndOptimizationModule;
